import React, { useEffect, useState } from "react";
import '../../CSS/TablaHerramientas.css'
import {BsPlus} from "react-icons/bs";
import axios from 'axios';
import { IoArrowUndo } from "react-icons/io5";
import {URI} from '../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import moment from "moment/moment";
import AgregarGasto from "./AgregarGasto";
import { getToken } from "../../Conexiones/Conexion";

function GastosOficina() {
    const navigate = useNavigate()
    const [gastos, setGastos] = useState([])
    const [listGastos, setListGastos] = useState([])
    const [busqueda,setBusqueda] = useState ('')
    const [totalGasto, setTotalGasto] = useState(0)

    useEffect( ()=>{
        const getGastos = async () =>{
            const res = await axios.get(URI + 'getGastosOficina',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setGastos(res.data)
            setListGastos(res.data)
        }
        getGastos()
    }, [navigate])

    useEffect(() => {
        const getTotalAdi = async () => {
            const res = await axios.get(URI+'getOficinaTotal',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setTotalGasto(res.data[0].total);
        }
        getTotalAdi();
    }, [navigate]);

    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
        console.log(e.target.value)
    }

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const total = formato(totalGasto)


    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = listGastos.filter((elemento)=> {
        if  (elemento.nombreAdicional.toString().toLowerCase().includes(textoIngresado.toLowerCase()) 
        || elemento.fecha.toString().toLowerCase().includes(textoIngresado.toLowerCase())
        ){  return elemento; }
        return resultadoBusqueda;
        });
        setGastos(resultadoBusqueda);
    }
    const regresar = () => {
        navigate('/inicio/oficina')
    }


    return (
        <div className="tablaHerramientas">
           <AgregarGasto/> 
            <div >
                <h3 className="text-uppercase tituloGastos">CONTROL DE GASTOS DE OFICINA</h3>
                <IoArrowUndo title="REGRESAR"  onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
            </div>

                    <div className='divboton' style={{margin:'5px 0'}}>                                                                                             
                        <div className='boton' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" data-bs-toggle="modal" data-bs-target="#modal-gasto-oficina" type="button">
                                <label className="agregar">REGISTRAR GASTO</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control " style={{width:'50%'}} type="search"  value={busqueda} placeholder="Concepto,fecha" onChange={buscar} aria-label="Search"/> 
                        </div>
                    </div>
                    <div className='divboton mb-2' style={{textAlign:'right'}}>
                        <div>
                            <strong><h5>{"TOTAL: $"+total}</h5></strong>
                        </div>
                    </div>
                    { gastos.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                    <div className="caja-asistencia" >
                        <div className="table tabla">
                            <table className="table  text-uppercase">
                                <thead >
                                    <tr >
                                        <th>CONCEPTO</th>
                                        <th>CANTIDAD</th>
                                        <th>PRECIO</th>
                                        <th>TOTAL</th>
                                        <th>FECHA</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {gastos.map(g =>{
                                        return(
                                            <tr key={g.idGasto}>
                                                <td>{g.nombreAdicional}</td>
                                                <td>{g.cantidad}</td>
                                                <td>$ {g.precio}</td>
                                                <td>$ {g.total}</td>
                                                <td>{moment(g.fecha).format("DD-MM-YYYY")}</td>
                                            </tr>                             
                                        )
                                    })}                        
                                </tbody>
                            </table>
                        </div>           
                    </div>
            )}
        </div>
    );
}

export default GastosOficina;